import { useEffect } from "react";
import { useVisibleContainer } from "../hooks/useVisibleContainer";
import { loadGiftsData } from "../../giftsApi";

// Route-effect component for "/gifts/drop/:id". Renders nothing -
// PrivateDropLockedPage.tsx (mounted unconditionally in AppRoot) owns the
// actual rendering into #privateDropView and reads the :id param itself,
// same pattern as every other route screen (see GiftsRouteScreen.tsx).
// Reloads gifts on mount so a direct nav/refresh straight to this URL has
// current lock state rather than whatever was last loaded elsewhere.
export function PrivateDropRouteScreen() {
  useVisibleContainer("privateDropView");

  useEffect(() => {
    loadGiftsData();
  }, []);

  return null;
}
